<template>
	<JBox>
		<JBox>
			<JHeadline class="s-text-lg">Add new</JHeadline>
			<JText class="s-text-gray-500">
				You can register a new subdomain on the quote.hk top level domain. This subdomain is mostly for testing purposes and uat
				environments.
			</JText>
		</JBox>
		<JFlex class="s-items-center s-mt-4">
			<JBox class="s-w-full">
				<JInputText v-model="createHost.subdomain" placeholder="my-new-app" class="s-text-right" @blur="onBlur" />
			</JBox>
			<JFlex class="s-pl-1"> .{{ createHost.domain }} </JFlex>
		</JFlex>
		<JText class="s-text-red-500 s-text-xs" v-if="$v.createHost.subdomain.$error">This field is required</JText>

		<!-- Buttons -->
		<JFlex class="s-mt-8 s-items-center">
			<JButton @click="addHostToTenant">Create</JButton>
			<JButton variant="white" class="s-ml-2" @click="$emit('cancel')">Cancel</JButton>
			<JSpinner type="dots" v-if="isLoading" class="s-ml-2" />
		</JFlex>

		<!-- Error -->
		<JText v-if="errorMessage" class="s-text-red-600 s-mt-4">
			{{ errorMessage }}
		</JText>
	</JBox>
</template>

<script>
import api from "@/api/api"
import { mutation } from "../api/queries"
import kebabCase from "lodash.kebabcase"
import { required } from "vuelidate/lib/validators"

export default {
	props: {
		value: String
	},

	validations: {
		createHost: {
			subdomain: { required }
		}
	},

	data() {
		return {
			isLoading: false,
			createHost: {
				subdomain: "",
				domain: "quote.hk"
			},

			errorMessage: ""
		}
	},

	methods: {
		async addHostToTenant() {
			if (this.isLoading) return // prevent double submit
			this.errorMessage = "" // reset

			// Validate form
			this.$v.$touch()
			if (this.$v.$invalid) return

			const { subdomain, domain } = this.createHost
			const host = `${subdomain}.${domain}`

			this.isLoading = true
			const res = await api({ query: mutation.addHostToTenantSettings, variables: { host } })
			this.isLoading = false

			if (res?.data?.addHostToTenantSettings?.status !== "success") {
				this.errorMessage = res?.data?.addHostToTenantSettings?.errors?.[0] ?? "Oops, something went wrong."
				return
			}

			this.$emit("created")
		},

		onBlur() {
			this.createHost.subdomain = this.makeKebabCase(this.createHost.subdomain)
			this.$v.createHost.subdomain.$touch()
		},

		makeKebabCase(value) {
			return kebabCase(value)
		}
	}
}
</script>
